import { useEffect, useState } from "react";

const isField = (el) => el && (el.tagName === "TEXTAREA" || (el.tagName === "INPUT" && !["checkbox", "radio", "range", "file", "color", "button", "submit"].includes(el.type)));

// True while a phone's on-screen keyboard is open; keeps the focused box visible above it.
export const useKeyboardOpen = (enabled = true) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!enabled) return undefined;
    const vv = window.visualViewport;
    const reveal = () => { const el = document.activeElement; if (isField(el)) el.scrollIntoView({ block: "center", behavior: "smooth" }); };
    const check = () => setOpen(isField(document.activeElement) && (!vv || window.innerHeight - vv.height > 120 || matchMedia("(pointer: coarse)").matches));
    let t;
    const onFocus = (e) => { if (!isField(e.target)) return; check(); clearTimeout(t); t = setTimeout(() => { check(); reveal(); }, 350); };
    const onBlur = () => setTimeout(check, 400);
    const onResize = () => setTimeout(check, 400);
    document.addEventListener("focusin", onFocus);
    document.addEventListener("focusout", onBlur);
    vv?.addEventListener("resize", onResize);
    return () => { clearTimeout(t); document.removeEventListener("focusin", onFocus); document.removeEventListener("focusout", onBlur); vv?.removeEventListener("resize", onResize); };
  }, [enabled]);
  return enabled && open;
};
